import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { updateDb } from "../services/updateDb";

import LoadPage from "../common/LoadPage";
import ConfirmationModal from "../common/ConfirmationModal";
import useAxiosFetch from "../common/useAxiosFetch";
import { Button } from "react-bootstrap";

import AlertMessage from '../common/AlertMessage';
import { useAppContext } from '../AppContext';
import { useTranslation } from "react-i18next";
import { MODAL_TYPES } from "../modals/ModalManager";

const OrganizationPage = () => {
  const { t } = useTranslation();
  const { alertMessage, showAlertMessage, triggerHeaderRefresh, openModal } = useAppContext();
  const [show, setShow] = useState(false);
  const [deleteOrg, setDeleteOrg] = useState();
  const navigate = useNavigate();
  const { data, loading, refetch } = useAxiosFetch("/api/organizations");
  const { data: featureLimits } = useAxiosFetch("/api/features/limits");

  const handleClose = async (deleteOrg, orgId) => {
    setShow(false);

    if (deleteOrg && orgId) {
      const res = await updateDb("/api/organizations/" + orgId, {}, "delete");

      if (res.success) {
        triggerHeaderRefresh();
        refetch();
        showAlertMessage('error', t('organization') + " " + t('deleted'));

      }
      else {
        showAlertMessage('error', res.error ? res.error : 'Error deleting organization.');
      }
    }
  };

  const handleShow = (orgId) => {
    setDeleteOrg(orgId);
    setShow(true);
  };

  let navigateEditOrg = (orgId) => {
    navigate(`/editorg?orgId=${orgId}`);
  };

  const handleAddOrganization = (e) => {
    e.preventDefault();
    
    if (featureLimits) {
      const { current } = featureLimits.usage.organizations;
      const maxOrganizations = featureLimits.limits.maxOrganizations;
      
      // Check if limit reached
      if (maxOrganizations !== -1 && current >= maxOrganizations) {
        openModal(MODAL_TYPES.UPGRADE, {
          featureType: 'Organizations',
          currentLimit: maxOrganizations,
          currentCount: current,
          recommendedPlan: 'premium'
        });
        return;
      }
    }
    
    navigate('/addorg');
  };

  if (loading)
    return <LoadPage />;
  
  return (
    <div id="content">
      <div id="content-title">{t('organizations')}</div>

      <div className="clear-both" />

      <ConfirmationModal
        show={show}
        handleClose={handleClose}
        deleteId={deleteOrg}
      />

      <Button 
        className="add-btn btn-right-top" 
        variant="primary" 
        type="button"
        onClick={handleAddOrganization}
      >
        +
      </Button>

      <AlertMessage type={alertMessage.type} message={alertMessage.content} />

      <div className="content-bubble content-bubble-table">
        <table className="overview-table">
          <thead>
            <tr>
              <td>{t('organization')}</td>
              <td>{t('owner_without_prefix')}</td>
              <td>{t('domains')}</td>
              <td>{t('security_standard')}</td>
              <td />
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <tr key={item["id"]}>
                  <td>{item.name}</td>
                  <td>{item.ownerUser}</td>
                  <td>{item.projects.map((project) => project.name).join(", ")}</td>
                  <td>{item.securityStandard || "ISO27001"}</td>
                  <td>
                    <i
                      onClick={() => navigateEditOrg(item["id"])}
                      className="icon-edit"
                    />
                    {item.projects.length === 0 ? (
                    <i
                      onClick={() => handleShow(item["id"])}
                      className="icon-delete"
                    />) : (
                      <i className="icon-delete" style={{color: "gray", cursor: "default"}} />
                    ) }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrganizationPage;
